import React, { useState } from 'react';
import { PhoneIcon, MailIcon, MapPinIcon, ClockIcon, UploadIcon, XIcon, ImageIcon } from 'lucide-react';
const ContactForm = () => {
  const [files, setFiles] = useState([]);
  const handleFileChange = e => {
    if (e.target.files) {
      const newFiles = Array.from(e.target.files);
      setFiles(prev => [...prev, ...newFiles]);
    }
  };
  const removeFile = index => {
    setFiles(files.filter((_, i) => i !== index));
  };
  return <section id="kontakt" className="py-16 bg-gray-50" data-id="element-29">
      <div className="container mx-auto px-4" data-id="element-30">
        <h2 className="text-3xl font-bold text-center mb-12 text-gray-900" data-id="element-31">
          Võta meiega ühendust
        </h2>
        <div className="flex flex-col md:flex-row gap-8" data-id="element-32">
          <div className="md:w-1/2 bg-white p-6 rounded-lg shadow-md" data-id="element-33">
            <h3 className="text-2xl font-semibold mb-6 text-blue-900" data-id="element-34">
              Saada päring
            </h3>
            <form data-id="element-35">
              <div className="mb-4" data-id="element-36">
                <label htmlFor="contactName" className="block text-sm font-medium mb-1" data-id="element-37">
                  Nimi *
                </label>
                <input type="text" id="contactName" className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" required data-id="element-38" />
              </div>
              <div className="mb-4" data-id="element-39">
                <label htmlFor="contactEmail" className="block text-sm font-medium mb-1" data-id="element-40">
                  E-post *
                </label>
                <input type="email" id="contactEmail" className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" required data-id="element-41" />
              </div>
              <div className="mb-4" data-id="element-42">
                <label htmlFor="contactAddress" className="block text-sm font-medium mb-1" data-id="element-43">
                  Tööde aadress *
                </label>
                <input type="text" id="contactAddress" className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="Tänav, maja, korter, linn" required data-id="element-44" />
              </div>
              <div className="mb-4" data-id="element-45">
                <label htmlFor="contactMessage" className="block text-sm font-medium mb-1" data-id="element-46">
                  Kirjeldus/mõtted/küsimused/ideed *
                </label>
                <textarea id="contactMessage" rows={4} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="Kirjeldage oma soove ja vajadusi võimalikult täpselt" required data-id="element-47"></textarea>
              </div>
              <div className="mb-6" data-id="element-48">
                <label className="block text-sm font-medium mb-2" data-id="element-49">
                  Piltide lisamine
                </label>
                <div className="flex items-center justify-center w-full" data-id="element-50">
                  <label className="flex flex-col items-center justify-center w-full h-32 border-2 border-dashed rounded-lg cursor-pointer border-gray-300 bg-gray-50 hover:bg-gray-100" data-id="element-51">
                    <div className="flex flex-col items-center justify-center pt-5 pb-6" data-id="element-52">
                      <UploadIcon size={32} className="text-gray-400 mb-2" data-id="element-53" />
                      <p className="mb-2 text-sm text-gray-500" data-id="element-54">
                        <span className="font-semibold" data-id="element-55">
                          Kliki failide lisamiseks
                        </span>{' '}
                        või lohista failid siia
                      </p>
                      <p className="text-xs text-gray-500" data-id="element-56">
                        PNG, JPG või JPEG (max 10MB)
                      </p>
                    </div>
                    <input type="file" className="hidden" multiple accept="image/png, image/jpeg, image/jpg" onChange={handleFileChange} data-id="element-57" />
                  </label>
                </div>
                {files.length > 0 && <div className="mt-3" data-id="element-58">
                    <p className="text-sm font-medium mb-2" data-id="element-59">Lisatud pildid:</p>
                    <div className="grid grid-cols-2 sm:grid-cols-3 gap-2" data-id="element-60">
                      {files.map((file, index) => <div key={index} className="relative group" data-id="element-61">
                          <div className="h-24 rounded-md bg-gray-100 flex items-center justify-center border border-gray-200 overflow-hidden" data-id="element-62">
                            <div className="absolute inset-0 flex items-center justify-center" data-id="element-63">
                              {file.type.startsWith('image/') ? <img src={URL.createObjectURL(file)} alt={`Upload ${index + 1}`} className="h-full w-full object-cover" data-id="element-64" /> : <ImageIcon size={24} className="text-gray-400" data-id="element-65" />}
                            </div>
                            <button type="button" onClick={() => removeFile(index)} className="absolute top-1 right-1 bg-red-500 text-white rounded-full p-1 opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-66">
                              <XIcon size={16} data-id="element-67" />
                            </button>
                          </div>
                          <p className="text-xs truncate mt-1" data-id="element-68">{file.name}</p>
                        </div>)}
                    </div>
                  </div>}
              </div>
              <button type="submit" className="w-full bg-blue-900 text-white py-2 px-4 rounded-md hover:bg-blue-800 transition duration-300" data-id="element-69">
                Saada päring
              </button>
            </form>
          </div>
          <div className="md:w-1/2" data-id="element-70">
            <div className="bg-white p-6 rounded-lg shadow-md mb-6" data-id="element-71">
              <h3 className="text-2xl font-semibold mb-4 text-blue-900" data-id="element-72">
                Kontaktinfo
              </h3>
              <div className="space-y-4" data-id="element-73">
                <div className="flex items-start" data-id="element-74">
                  <PhoneIcon size={20} className="text-blue-900 mr-3 mt-1 flex-shrink-0" data-id="element-75" />
                  <div data-id="element-76">
                    <p className="font-medium" data-id="element-77">Telefon</p>
                    <p className="text-gray-700" data-id="element-78">
                      <a href="tel:55613203" className="hover:underline" data-id="element-79">
                        55613203
                      </a>
                    </p>
                  </div>
                </div>
                <div className="flex items-start" data-id="element-80">
                  <MailIcon size={20} className="text-blue-900 mr-3 mt-1 flex-shrink-0" data-id="element-81" />
                  <div data-id="element-82">
                    <p className="font-medium" data-id="element-83">E-post</p>
                    <p className="text-gray-700" data-id="element-84">
                      <a href="mailto:veikokirsman@gmail.com" className="hover:underline" data-id="element-85">
                        veikokirsman@gmail.com
                      </a>
                    </p>
                  </div>
                </div>
                <div className="flex items-start" data-id="element-86">
                  <MapPinIcon size={20} className="text-blue-900 mr-3 mt-1 flex-shrink-0" data-id="element-87" />
                  <div data-id="element-88">
                    <p className="font-medium" data-id="element-89">Teeninduspiirkond</p>
                    <p className="text-gray-700" data-id="element-90">Viljandimaa ja kogu Eesti</p>
                  </div>
                </div>
                <div className="flex items-start" data-id="element-91">
                  <ClockIcon size={20} className="text-blue-900 mr-3 mt-1 flex-shrink-0" data-id="element-92" />
                  <div data-id="element-93">
                    <p className="font-medium" data-id="element-94">Tööaeg</p>
                    <p className="text-gray-700" data-id="element-95">E-R: 9:00 - 18:00</p>
                    <p className="text-gray-700" data-id="element-96">L: Kokkuleppel</p>
                    <p className="text-gray-700" data-id="element-97">P: Suletud</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-98">
              <h3 className="text-xl font-semibold mb-4 text-blue-900" data-id="element-99">
                Mööbli paigalduse hinnad
              </h3>
              <p className="text-gray-700 mb-3" data-id="element-100">
                Hinnad sõltuvad mööbli tüübist ja keerukusest. Võta meiega
                ühendust tasuta hinnapakkumise saamiseks.
              </p>
              <p className="text-gray-700" data-id="element-101">
                Minimaalne väljakutse tasu Viljandimaal alates 30€.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
};
export default ContactForm;